__turbopack_context__.v({
  "className": "geist_f9eb73d1-module__xB26bW__className",
  "variable": "geist_f9eb73d1-module__xB26bW__variable",
});
